import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Container, Grid, Tab, Typography } from '@mui/material';
import config from 'src/config';
import { useNavigate, useParams } from 'react-router-dom';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import Duplicates from 'src/components/declutter/duplicates';
import Impact from 'src/components/declutter/impact';

// ----------------------------------------------------------------------

// Debounce function
function debounce(func, wait) {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}

class Declutter extends React.Component {


    constructor(props) {
        super(props);

        this.state = {

            current_tab: 'duplicate',

            files: [],
            file_containers: [],
            search: '',
            limit: 12,
            skip: 0,
            total_files: 0,
            total_size: 0,
            flags: [],
            labels: [],
            containers: [],
            file_ids: [],
            flagged: false,
            labelled: false,
            unorganized: true,
            organized: false,
            recent: true,
            recent_type: 'last_week',
            service: [],
            extension: [],
            advanced_search: false,
            show_selection: false,
            selected: {
                files: [],
                total_size: 0
            },
            select_all: false,
            addLabelModal: false,
            addFlagModal: false
        };
    }


    // promised setState
    setStateAsync(state) {
        return new Promise((resolve) => {
            this.setState(state, resolve)
        });
    }

    render() {
        return (
            <>
                <Helmet>
                    <title> Declutter | {config.APP_NAME} </title>
                </Helmet>

                <Box sx={{ width: '100%', typography: 'body1' }}>
                    <TabContext value={this.state.current_tab}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={(e, value) => {
                                this.setState({ current_tab: value })
                            }}>
                                <Tab label="Action" value="duplicate" />
                                <Tab label="Impact" value="impact" />
                            </TabList>
                        </Box>
                        <TabPanel value="duplicate">
                            <Duplicates />
                        </TabPanel>
                        <TabPanel value="impact">
                            <Impact />
                        </TabPanel>
                    </TabContext>
                </Box>

            </>
        );
    }
}

// Wrap and export
export default function (props) {
    const navigate = useNavigate();
    const params = useParams();

    return <Declutter {...props} navigate={navigate} params={params} />;
}
